import { FunctionComponent, useEffect, useState } from 'react'

import styled from 'styled-components'

import useCMPHasUserInteracted from '@hooks/useCMPHasUserInteracted'
import useGetContentAccessStatus from '@hooks/useGetContentAccessStatus'
import useSubscriptionStatus from '@hooks/useSubscriptionStatus'
import { GenericWidget } from '@widgets/Body'
import { bodyStyle } from '@widgets/Body/bodyStyle'
import JSONRenderer from '@components/JSONRenderer'

interface PlusContentWrapperProps {
  children: GenericWidget[] | null
}

const StyledPaywallWrapper = styled.div`
  ${bodyStyle}

  // This is used to blur out the content for a paywall test
  &.piano-blur > *:not(aside) {
    filter: blur(10px);
    user-select: none;
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    pointer-events: none;
  }
`

const PlusContentWrapper: FunctionComponent<PlusContentWrapperProps> = ({
  children,
}) => {
  const [hideWidget, setHideWidget] = useState<boolean>(false)
  const { subscriptionStatus } = useSubscriptionStatus()
  const { contentHidden } = useGetContentAccessStatus()
  const hasUserInteracted = useCMPHasUserInteracted()

  useEffect(() => {
    // Piano is loaded after the user has given consent (see PR 1274), and the "paid widgets" are hidden after Piano paywall is shown.
    // When the CMP popup is initially shown, it is possible to scroll over the article in the background.
    // That's why we need to hide the paid content until the user has given the consent.
    if (!hasUserInteracted) {
      setHideWidget(true)
    } else {
      const shouldHide =
        contentHidden &&
        // We also need to check subscription status because he/she should see plus content, in case he/she has a print abo
        subscriptionStatus === 'notSubscribed'
      setHideWidget(shouldHide)
    }
  }, [contentHidden, subscriptionStatus, hasUserInteracted])

  if (!children) {
    return null
  }

  return (
    // We need a classname here, to reference the paywall content in the schema for SEO
    <StyledPaywallWrapper className="paywallContent">
      {hideWidget ? null : <JSONRenderer>{children}</JSONRenderer>}
    </StyledPaywallWrapper>
  )
}

export default PlusContentWrapper
